jQuery(function ($) {
    //Product Slider
    $('.ProductSlider').owlCarousel({
        loop: true,
        margin: 45,
        dots: false,
        nav: true,
        autoplay: true,
        autoplayTimeout: 4000,
        autoplayHoverPause: true,
        responsiveClass: true,
        navText: ['<span class="fa fa-angle-left"></span>','<span class="fa fa-angle-right"></span>'],
        items: 4,
        responsive: {
            0: {
                items: 2,
                margin: 10
            },
            391: {
                items: 2,
                margin: 20
            },
            768: {
              items: 3,
              margin: 10
            },
            1024: {
              margin: 20
            },
            1199: {
              margin: 25
            },
            1367: {
              margin: 35
            },
            1441: {
                margin: 40
            }
        }
    })
    //    < ------------------------------------------------------>
    //Product Slider
    $('.FeaturedProductSlider').owlCarousel({
        loop: true,
        margin: 45,
        dots: false,
        nav: true,
        autoplay: true,
        autoplayTimeout: 4000,
        autoplayHoverPause: true,
        responsiveClass: true,
        navText: ['<span class="fa fa-angle-left"></span>','<span class="fa fa-angle-right"></span>'],
        items: 4,
        responsive: {
            0: {
                items: 2,
                margin: 10
            },
            391: {
                items: 2,
                margin: 20
            },
            768: {
              items: 3,
              margin: 10
            },
            1024: {
              margin: 20
            },
            1199: {
              margin: 25
            },
            1367: {
              margin: 35
            },
            1441: {
                margin: 40
            }
        }
    })
    //    < ------------------------------------------------------>
    //Blog Slider
    $('.BlogSlider').owlCarousel({
        loop: true,
        margin: 45,
        dots: false,
        nav: true,
        autoplay: true,
        autoplayTimeout: 4000,
        autoplayHoverPause: true,
        responsiveClass: true,
        navText: ['<span class="fa fa-angle-left"></span>','<span class="fa fa-angle-right"></span>'],
        items: 3,
        responsive: {
            0: {
                items: 1,
                margin: 10
            },
            391: {
                items: 1,
                margin: 20
            },
            768: {
              items: 3,
              margin: 10
            },
            1024: {
              margin: 20
            },
            1199: {
              margin: 25
            },
            1367: {
              margin: 35
            },
            1441: {
                margin: 40
            }
        }
    })
    //    < ------------------------------------------------------>
    //Review Slider
    $('.ReviewSlider').owlCarousel({
        loop: true,
        margin: 0,
        dots: false,
        nav: true,
        autoplay: true,
        autoplayTimeout: 4000,
        autoplayHoverPause: true,
        responsiveClass: true,
        navText: ['<span class="fa fa-angle-left"></span>','<span class="fa fa-angle-right"></span>'],
        items: 1
    })
    //    < ------------------------------------------------------>
    //Collection Slider
    $('.CollectionSlider').owlCarousel({
        loop: true,
        margin: 20,
        dots: false,
        nav: true,
        autoplay: true,
        autoplayTimeout: 4000,
        autoplayHoverPause: true,
        responsiveClass: true,
        navText: ['<span class="fa fa-angle-left"></span>','<span class="fa fa-angle-right"></span>'],
        items: 2,
        responsive: {
            0: {
                margin: 10
            }
        }
    })
    //    < ------------------------------------------------------>
    //Instagram Slider
    $('.InstagramSlider').owlCarousel({
        loop: true,
        margin: 20,
        dots: false,
        nav: true,
        autoplay: true,
        autoplayTimeout: 4000,
        autoplayHoverPause: true,
        responsiveClass: true,
        navText: ['<span class="fa fa-angle-left"></span>','<span class="fa fa-angle-right"></span>'],
        items: 2,
        responsive: {
            0: {
                margin: 10
            }
        }
    })
    //    < ------------------------------------------------------>
});